import React from 'react';

import Icon from '../Icon/Icon';

const ExtraFeaturesRestrictedIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M18.667 8v32M40 16.392V40M8 22.435V40'
                stroke='#272A33'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M29.333 28.363V40' stroke='#00D1D2' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </Icon>
    );
};

export default ExtraFeaturesRestrictedIcon;
